import { render, staticRenderFns } from "./PosInstallAlert.vue?vue&type=template&id=2b6229e1&"
import script from "./PosInstallAlert.vue?vue&type=script&lang=js&"
export * from "./PosInstallAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports